import { environment } from '$env';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Models } from '../../../../shared/models';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  http = inject(HttpClient);
  public bidDepositStatus = (id: number) =>
    this.http.post<Models.BidDepositStatus>(environment.endpoints.apiUrl + 'bidding/deposit/my/status', { CUSTOMER_ID: id });
}
